<svg width="35" height="35" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32.25 19.5L21.2499 30L15.75 24.75" stroke="#08C052" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" />
    <path
        d="M24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42Z"
        stroke="#08C052" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>